import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../assets/Images/loader.gif";
import * as api from "../../api_function";

const BusinessSitedetails = () => {
    const [verticalOptions, setVerticalOptions] = useState([]);
    const [selectedVertical, setSelectedVertical] = useState(null);
    const [activeForm, setActiveForm] = useState("form21");
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selectedRelationship, setSelectedRelationship] = useState(null);
    const handleRelationshipChange = (selectedOption) => {
        setSelectedRelationship(selectedOption);
        setSiteData((prevData) => ({
            ...prevData,
            Relationship: selectedOption.value,
        }));
    };
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const SiteID = searchParams.get("SiteID");
    const navigate = useNavigate();
    const options = [
        { value: "SDWAN Price list", label: "SDWAN Price list" }
    ];
    const [selectedPriceList, setSelectedPriceList] = useState(options[0]);

    const handlePriceListChange = option => {
        setSelectedPriceList(option);
    };
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [OppId2, setOppId2] = useState("");

    const [productOptions, setProductOptions] = useState([]);
    const [opportunityData, setOpportunityData] = useState({
        Remarks: "",
        Redunancy: false,
        Block: "",
        Status: "",
        Statuscode: "",
        OppId: "",
        OppStatus: "",
        LeadId: "",
        PriceList: "",
        Topic: "",
        StateId: "",
        CityId: "",
        AreaId: "",
        BuildingId: "",
        SpecificArea: "",
        SpecificBuilding: "",
        Building_BuildingStatus: "",
        NoOfUsers: "",
        NoOfBeds: "",
        IndustryId: "",
        ApprovalRequiredFlag: "",
        Reason: "",
        Area: "",
        Subbusinesssegment: "",
        Businesssegment: "",
        State: "",
        Salutation: "",
        Relationship: "",
        PostalCode: "",
        Mobilephone: "",
        Media: "",
        Lco: null,
        Industry: "",
        Group: "",
        Floor: "",
        TPFeasibilty: "",
        CreateAreaOrBuilding: false,
        Firmtype: "",
        Product: "",
        ProductSegment: "",
        FeasibilityRequired: false,
        Existingprovider: "",
        Emailaddress: "",
        Country: "",
        Companyname: "",
        City: "",
        leadname: "",
        Buildingname: "",
        BuildingNo: "",
        ContactPerson: "",
        CustomerSegment: "",
        LastMileType: "",
        UpTimesla: "",
        Firewall: "",
        CompanySelf: "",
        PoLock: "",
        Price: "",
        OriginatingLead: "",
        FirewallAwc: "",
        PoNext: "",
        Company: "",
        TotalAmount: "",
        VerticalID: "",
        TypeOfOrder: "",
        PocClosureDate: "",
        TurnOver: "",
        SocietyName: "",
        SocietyId: "",
        SocietyStatus: "",
        HousePlotFlatNo: "",
        BlockTowerNumber: "",
        OTCAmount: "",
        SDAmount: "",
        RCAmount: "",
        sdDiscount: "",
        rcDiscount: "",
        otcDiscount: "",
        exOtcDiscount: "",
        exSdDiscount: "",
        exRcDiscount: ""
    });
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        // console.log(name, value);

        setOpportunityData((prevData) => ({
            ...prevData,
            [name]: value,
        }));


    };
    const [getOTCProd, setOTCProd] = useState([]);
    const [getRCProd, setRCProd] = useState([]);

    const discountInput = async (e) => {
        const { name, value } = e.target;
        // console.log(name, value, getOTCProd[0], getRCProd[0]);

        // if(!selectedRelatedProduct?.value){
        //   toast.error("Select related product");
        //   return
        // }

        if (name == 'otcDiscount') {

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, discount: opportunityData.otcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);
        } else if (name == 'rcDiscount') {

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, discount: opportunityData.rcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);
        }
    };
    const [discountFlag, setDiscountFlag] = useState();

    const [relatedProductOptions, setRelatedProductOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);


    useEffect(() => {
        const getCompanyGrouplist = async () => {
            const getCompany = await api.getCompanyGroup("New Company")
            const oppProduct = await api.getOppProduct({ oppid: OppId });
            // console.log(oppProduct);
            // console.log(oppProduct.Response?.Data);

            let relProductRC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-RC"))
            let relProductOTC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-OTC"))

            // console.log(relProductRC, relProductOTC);
            setRCProd(relProductRC)
            setOTCProd(relProductOTC)


            setRelatedProductOptions(oppProduct?.Response?.Data?.map((data) => (
                {
                    value: data.ProductId,
                    label: data.ProductId
                    ,
                }
            )))

            // selectedRelatedProduct()
            // relatedProductOptions()

            setGroupOptions(getCompany?.Response?.Data?.map((data) => (
                {
                    value: data.Group_ID,
                    label: data.Group_Name,
                }
            )))

            setCompanyOptions(getCompany.Response.Data?.map((data) => (
                {
                    value: data.Company_ID,
                    label: data.Company_Name,
                }
            )))
        };

        getCompanyGrouplist()

    }, []);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {

                    // Action: "getOppProduct",
                    Action: "getProductlist",


                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    oppid: "",
                    reason: "",
                    siteId: SiteID,
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                // Send API request
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                const result = await response.json();
                // console.log(result);

                if (result?.Status === "Success") {
                    // const productList = result.Response.Data.map(item => item.ProductId);
                    // console.log("result.Response.Data", result.Response.Data)
                    const productList = result.Response.Data.map(
                        (option) => ({
                            label: option.ProductId,
                            value: option.ProductId,
                        })
                    );
                    setProductOptions(productList);
                }
            } catch (error) {
                console.error("Error fetching product list:", error);
            }
        }; fetchData();
    }, []);


    const fetchData = async (OppId2) => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getopportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                LeadId: "",
                OppId: OppId ? OppId : OppId2,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const responsedata = await response.json();
            const responseData = responsedata?.Response?.Data?.[0];
            // console.log("test");

            // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

            // console.log("getLeads1" ,responsedata1);
            if (responsedata?.Status === "Success" && responseData) {
                // console.log("test12345", opportunityData?.Product, opportunityData?.otcDiscount, opportunityData?.rcDiscount);
                setOpportunityData({
                    Remarks: responseData.Remarks || "",
                    Redunancy: responseData.Redunancy || false,
                    Block: responseData.Block || "",
                    Status: responseData.Status || "",
                    Statuscode: responseData.Statuscode || "",
                    OppId: responseData.OppId || "",
                    OppStatus: responseData.Statuscode || "",
                    LeadId: responseData.LeadId || "",
                    PriceList: responseData.PriceList || "",
                    Topic: responseData.Topic || "",
                    // StateId: responseData.StateId || "",
                    // CityId: responseData.CityId || "",
                    // AreaId: responseData.AreaId || "",
                    BuildingId: responseData.BuildingId || "",
                    SpecificArea: responseData.SpecificArea || "",
                    SpecificBuilding: responseData.SpecificBuilding || "",
                    Building_BuildingStatus: responseData.Building_BuildingStatus || "",
                    NoOfUsers: responseData.NoOfUsers || "",
                    NoOfBeds: responseData.NoOfBeds || "",
                    // IndustryId: responseData.IndustryId || "",
                    ApprovalRequiredFlag: responseData.ApprovalRequiredFlag || "",
                    Reason: responseData.Reason || "",
                    Area: responseData.Area || "",
                    Subbusinesssegment: responseData.Subbusinesssegment || "",
                    Businesssegment: responseData.Businesssegment || "",
                    // State: responseData.State || "",
                    // Salutation: responseData.Salutation || "",
                    Relationship: responseData.Relationship || "",
                    PostalCode: responseData.PostalCode || "",
                    Mobilephone: responseData.Mobilephone || "",
                    Media: responseData.Media || "",
                    Lco: responseData.Lco || null,
                    // Industry: responseData.Industry || "",
                    Group: responseData.Group || "",
                    Floor: responseData.Floor || "",
                    TPFeasibilty: responseData.TPFeasibilty || "",
                    CreateAreaOrBuilding: responseData.CreateAreaOrBuilding || false,
                    Firmtype: responseData.Firmtype || "",
                    Product: responseData.Product || "",
                    ProductSegment: responseData.ProductSegment || "",
                    FeasibilityRequired: responseData.FeasibilityRequired || false,
                    Existingprovider: responseData.Existingprovider || "",
                    Emailaddress: responseData.Emailaddress || "",
                    // Country: responseData.Country || "",
                    Companyname: responseData.leadname || "",
                    // City: responseData.City || "",
                    leadname: responseData.leadname || "",
                    Buildingname: responseData.Buildingname || "",
                    BuildingNo: responseData.BuildingNo || "",
                    ContactPerson: responseData.ContactPerson || "",
                    CustomerSegment: responseData.CustomerSegment || "",
                    LastMileType: responseData.LastMileType || "",
                    UpTimesla: responseData.UpTimesla || "",
                    Firewall: responseData.Firewall || "",
                    // CompanySelf: responseData.CompanySelf || "",
                    PoLock: responseData.PoLock || "",
                    Price: responseData.Price || "",
                    OriginatingLead: responseData.OriginatingLead || "",
                    FirewallAwc: responseData.FirewallAwc || "",
                    PoNext: responseData.PoNext || "",
                    // Company: responseData.Company || "",
                    TotalAmount: responseData.TotalAmount || "",
                    VerticalID: responseData.VerticalID || "",
                    TypeOfOrder: responseData.TypeOfOrder || "",
                    PocClosureDate: responseData.PocClosureDate || "",
                    TurnOver: responseData.TurnOver || "",
                    SocietyName: responseData.SocietyName || "",
                    SocietyId: responseData.SocietyId || "",
                    SocietyStatus: responseData.SocietyStatus || "",
                    HousePlotFlatNo: responseData.HousePlotFlatNo || "",
                    BlockTowerNumber: responseData.BlockTowerNumber || "",
                    OTCAmount: responseData.OTCAmount || "",
                    SDAmount: responseData.SDAmount || "",
                    RCAmount: responseData.RCAmount || "",
                    sdDiscount: responseData.SDDiscountAmount || "",
                    otcDiscount: responseData.OTCDisocuntAmountB || "",
                    rcDiscount: responseData.RCDisocuntAmountB || "",
                    exOtcDiscount: responseData.OTCExtendedAmountB || "",
                    exSdDiscount: responseData.SDExtendedAmount || "",
                    exRcDiscount: responseData.RCExtendedAmountB || ""
                });
                // console.log("test2");
                // console.log("sdwanOpp0", responseData.sdwanOpp);

                // console.log("OTCAmount0", responseData.OTCAmount);


                // if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus == "Non-RFS") {
                //     setEnableGenerateFeasibilityBtn(true)
                //     setIsRedundancyLocked(false)
                // }
                // if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus !== "Non-RFS") {
                //     setEnableGenerateFeasibilityBtn(false)
                //     setIsRedundancyLocked(true)
                // }
                // if ((responseData?.ProductSegment == "Secured Managed Internet" || responseData?.ProductSegment == "Managed Office Solution") && responseData?.Redunancy == true) {
                //     setEnableGenerateFeasibilityBtn(true)
                //     setIsRedundancyLocked(true)
                // }
                // if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag !== 'YES' && responseData?.Redunancy == true) {
                //     setEnableGenerateFeasibilityBtn(true)
                //     setIsRedundancyLocked(false)
                // }
                // if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag == 'YES' && responseData?.Redunancy == true) {
                //     setEnableGenerateFeasibilityBtn(false)
                //     setIsRedundancyLocked(true)
                // }


                // const options = await fetchCompanyData("");
                // console.log(options);
                // let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
                // console.log(defaultCompanyGroupObj);
                // let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
                // console.log(defaultRelationship);

                // setSelectedCompany({
                //     value: defaultCompanyGroupObj?.value,
                //     label: defaultCompanyGroupObj?.label,
                // });

                // setSelectGroup({
                //     value: defaultCompanyGroupObj?.groupId,
                //     label: defaultCompanyGroupObj?.group,
                // });

                // // console.log(defaultRelationship);

                // if (defaultRelationship.Response?.length > 0) {
                //     let defaultRelationshipObj = defaultRelationship.Response?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
                //     console.log(defaultRelationshipObj);
                //     setSelectRelationship({
                //         value: defaultRelationshipObj?.Relationship_ID,
                //         label: defaultRelationshipObj?.Relationship_Name
                //     });
                // }
                // setOppSubSeg(responseData.Subbusinesssegment);

                setCompanyOptions(options);
                // setOtcDiscount(responseData?.OTCDisocuntAmountB)
                // setRcDiscount(responseData?.RCDisocuntAmountB)
                ///////////////////////////////////

                // setSdwanOpp(responseData.sdwanOpp);
                // console.log("test3");
                // console.log("sdwanOpp", responseData.sdwanOpp);

                // console.log("OTCAmount", responseData.OTCAmount);



                // setOtcAmountDis(responseData.OTCDiscountAmount);
                // setRcAmountDis(responseData.RCAmount);
                // setOtcAmount(responseData.OTCAmount);
                // setSdAmount(responseData.SDAmount);
                // setleadid(responseData.LeadId);
                // setSelectedPriceList(responseData.PriceList);
                // console.log("responseData.Product", responseData.Product)
                // setStatusCode(responseData.Statuscode);
                // setStatus(responseData.Status);
                // setSelectSociety(responseData.SocietyName);

                // setSelectedFirmType(firmtype.find(item => item.value === responseData.Firmtype));
                // setSelectedMedia(media.find(item => item.value === responseData.Media));
                // setSelectExServiceProvider1(ExServiceProvider.find(item => item.value === responseData.Existingprovider));
                // setSelectInterestedFirewall(optionInterestedFirewall.find(item => item.value === responseData.Firewall));
                // setSelectInteretedVPN(optionInterestedVPN.find(item => item.value === responseData.Redunancy));
                // setSelectInterestedManageWiFi(optionInterestedManageWiFi.find(item => item.value === responseData.CompanySelf));

                // console.log(ExServiceProvider.find(item => item.value === responseData.Existingprovider));

                let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })


                let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
                // if (defaultBuilding) {
                //     // console.log(defaultBuilding);
                //     setSelectBuilding({
                //         value: defaultBuilding.BuildingCode,
                //         label: defaultBuilding.BuildingName
                //     })
                // }

                setSelectedProduct({
                    value: responseData.Product,
                    label: responseData.Product,
                });

                setSelectedPriceList(
                    {
                        value: responseData.PriceList,
                        label: responseData.PriceList,
                    }
                )
                // setSelectCountry({
                //     value: responseData.Country,
                //     label: responseData.Country,
                // });
                setSelectState({
                    value: responseData.StateId,
                    label: responseData.State,
                })
                setSelectCity({
                    value: responseData.CityId,
                    label: responseData.City,
                })
                // setSelectArea({
                //     value: responseData.AreaId,
                //     label: responseData.Area,
                // })
                // setSelectIndustry({
                //     value: responseData.IndustryId,
                //     label: responseData.Industry,
                // })

                // const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment)).label;


                // setSelectCustomerSeg(
                //     {
                //         value: responseData.CustomerSegment,
                //         label: filterCustomerSegment,
                //     });
                // console.log("responseData.TurnOver",responseData.TurnOver);

                // const filterTurnOver = optionTurnOver?.find(item => item.value === String(responseData?.TurnOver)).label;
                // console.log("filterTurnOver",filterTurnOver);

                // setSelectTurnOver(
                //     {
                //         value: responseData.TurnOver,
                //         label: filterTurnOver,
                //     });
                // const filterSalutationId = optionSolutation.find(
                //     (item) => item.value === String(responseData.Salutation)
                // ).label;
                // setSelectSolutaton({
                //     value: responseData.Salutation,
                //     label: filterSalutationId,
                // });

                // console.log(companyOptions);

                // if (responseData?.Company) {
                //   setSelectedCompany({
                //     value: responseData.Company,
                //     label: responseData.Company,
                //   });
                // }

                //////////////
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // if ((segment == "BIA" || segment == "ILL") && BuildingStatus == "Non-RFS") {
                //   generateFeasibilityBtn(true)
                //   isRedundancyLocked(false)
                // }
                // if ((segment == "BIA" || segment == "ILL") && BuildingStatus !== "Non-RFS") {
                //   generateFeasibilityBtn(false)
                //   isRedundancyLocked(true)
                // }
                // if ((segment == "MBIA" || segment == "MBB") && RedundancyRequired == "YES") {
                //   generateFeasibilityBtn(true)
                //   isRedundancyLocked(false)
                // }
                // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag !== YES) {
                //   generateFeasibilityBtn(true)
                //   isRedundancyLocked(false)
                // }
                // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag == YES) {
                //   generateFeasibilityBtn(false)
                //   isRedundancyLocked(true)
                // }

            } else {
                console.error("Error fetching opportunity data:", responseData?.Message);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    // fetchData();

    useEffect(() => {
        // console.log("Updated OTCAmount:", opportunityData.OTCAmount);
        // console.log("Updated RCAmount:", opportunityData.RCAmount);
    }, [opportunityData]);

    useEffect(() => {
        fetchData();
    }, [OppId]);
    const redirectoppPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate(`/businessOpportunityForm?OppId=${OppId || OppId2}`);
            }
        });
    };





    const handleProductChange = async (selectedOption) => {
        setSelectedProduct(selectedOption);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "createOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId ? OppId : "",
                siteId: SiteID,
                password: sessionStorage.getItem('password'),
                productid: selectedOption.value,
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const responsedata = await response.json();

            if (responsedata.Status == "Failure") {
                toast.warning(responsedata.Response.Message.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else {
                fetchSiteData();
            }

        } catch (error) {
            // Handle fetch error
            console.error("Error fetching data:", error);
        }
    };
    const [createupdateSite, setcreateupdateSite] = useState(null);

    useEffect(() => {
        // console.log("SiteID", SiteID)
        // console.log("OppId", OppId)

        if (SiteID === null && OppId !== null) {
            setcreateupdateSite("createSite");
        } else if (OppId === null) {
            setcreateupdateSite("updateSite");
        }
    }, [SiteID, OppId]);

    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSiteData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleIconClick = (formId) => {
        // if (activeForm !== formId) {
        //   setActiveForm(formId);
        // }

        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };

    // Options for "Solution Deployment Modes"
    const solutionDeploymentModeOptions = [
        { value: "0", label: "Select Option" },
        { value: "122050000", label: "WL" },
        { value: "122050001", label: "WR" },
        { value: "122050002", label: "RR" },
        { value: "122050003", label: "RL" },
    ];

    // Options for "Site Category"
    const siteCategoryOptions = [
        { value: "0", label: "Select Option" },
        { value: "111260000", label: "On Cloud" },
        { value: "111260001", label: "On Premises" },
    ];

    // Options for "State" (mapping the provided array)
    const optionState = [
        { name: "Select State", code: "" },
        { name: "Andhra Pradesh", code: "100009" },
        { name: "Jharkhand", code: "100030" },
        { name: "Bihar", code: "100021" },
        { name: "Delhi", code: "100004" },
        { name: "Gujarat", code: "100015" },
        { name: "Haryana", code: "100008" },
        { name: "Jammu and Kashmir", code: "100011" },
        { name: "Karnataka", code: "100007" },
        { name: "Kerala", code: "100012" },
        { name: "Madhya Pradesh", code: "100014" },
        { name: "Maharashtra", code: "100002" },
        { name: "Odisha", code: "100026" },
        { name: "Other*", code: "100017" },
        { name: "Punjab", code: "100025" },
        { name: "Rajasthan", code: "100010" },
        { name: "Tamil Nadu", code: "100003" },
        { name: "Telangana", code: "100023" },
        { name: "Uttar Pradesh", code: "100006" },
        { name: "Uttarakhand", code: "100016" },
        { name: "West Bengal", code: "100013" },
        { name: "Goa", code: "100028" },
    ];
    const stateOptions = optionState.map((state) => ({
        value: state.code,
        label: state.name,
    }));
    const lanIpAllocationOptions = [
        { value: "0", label: "Select Option" },
        { value: "122050000", label: "Static" },
        { value: "122050001", label: "DHCP" },
    ];
    const [showLanModal, setShowLanModal] = useState(false);
    const [lanFormData, setLanFormData] = useState({
        lanIPAllocationtoUser: "", // Dropdown value
        ipAllocationRange: "",
        lanIpPool: "",
        lanIpAddress: "", // LAN IP Address@ISP CPE
        ipPoolGateway: "",
        lanIpPool2: "",
    });
    const wanIpAllocationOptions = [
        { value: "0", label: "Select Option" },
        { value: "122050000", label: "Static" },
        { value: "122050001", label: "DHCP" },
    ];

    // WAN Type options
    const wanTypeOptions = [
        { value: "0", label: "Select Option" },
        { value: "1", label: "Broadband" },
        { value: "2", label: "ILL" },
        { value: "3", label: "LTE" },
        { value: "4", label: "MPLS" },
    ];

    // WAN BB Provider options
    const wanBBProviderOptions = [
        { value: "0", label: "Select Option" },
        { value: "111260000", label: "Jio" },
        { value: "569480014", label: "ACT Fibernet" },
        { value: "569480012", label: "N.A" },
        { value: "569480013", label: "Others" },
        { value: "569480000", label: "Airtel" },
        { value: "569480002", label: "Aircel" },
        { value: "569480003", label: "BSNL" },
        { value: "569480004", label: "Hathway" },
        { value: "569480005", label: "MTNL" },
        { value: "569480006", label: "Nextra" },
        { value: "569480007", label: "Reliance Communications" },
        { value: "569480008", label: "Sify" },
        { value: "569480009", label: "Tata Communications" },
        { value: "569480010", label: "Tata DOCOMO" },
        { value: "569480011", label: "Tikona Infinet" },
        { value: "569480001", label: "Vodafone" },
    ];


    const handleLanChange = (e) => {
        const { name, value } = e.target;
        setLanFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Change handler for LAN IP Allocation to user dropdown
    const handleLanDropdownChange = (selectedOption) => {
        setLanFormData((prevData) => ({
            ...prevData,
            lanIPAllocationtoUser: selectedOption.value,
        }));
    };

    const [lanCards, setLanCards] = useState([]);

    // ----- WAN Modal States -----
    const [showWanModal, setShowWanModal] = useState(false);
    const [wanFormData, setWanFormData] = useState({
        wanIPAllocationtype: "",
        wanType: "",
        wanBandwidth: "",
        wanGateway: "",
        wanCircuitID: "",
        wanIPaddress: "",
        wanBBProvider: "",
    });
    const [wanCards, setWanCards] = useState([]);

    // --- Generic Handlers for WAN Modal ---
    const handleWanChange = (e) => {
        const { name, value } = e.target;
        setWanFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleWanDropdownChange = (name, selectedOption) => {
        setWanFormData((prev) => ({ ...prev, [name]: selectedOption.value }));
    };

    // ----- Fetch LAN Cards Data -----
    const fetchAllLan = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getAllLan",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                lanNo: "",
                // password: "S@lesperson@20#!24$",
                siteId: SiteID,
                // userName: "salesperson1",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName')
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });
            const result = await response.json();
            if (result.Status === "Success" && result.Response.Data) {
                setLanCards(result.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching LAN details", error);
        }
    };

    // ----- Fetch WAN Cards Data -----
    const fetchAllWan = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getAllWan",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                // password: "S@lesperson@20#!24$",
                siteId: SiteID,
                // userName: "salesperson1",
                wanNo: "",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName')
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });
            const result = await response.json();
            if (result.Status === "Success" && result.Response.Data) {
                setWanCards(result.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching WAN details", error);
        }
    };

    // Load LAN and WAN cards on mount
    useEffect(() => {
        fetchAllLan();
        fetchAllWan();
        fetchSiteData();
    }, []);


    const handleSaveWan = async () => {
        const payload = {
            Action: "createWan",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            additionalIPGatewayCPE: "",
            additionalIPPoolAllocationType: "",
            additionalIPPoolbetSpecCPEExistin: "",
            additionalIPconfiguredSpecCPE: " ",
            // password: "S@lesperson@20#!24$",
            siteId: SiteID,
            // userName: "salesperson1",
            wANBBProvider1D: wanFormData.wanBBProvider,
            wANBBProvider2: "",
            wANBandwidthinMbps: wanFormData.wanBandwidth,
            wANCircuitID: wanFormData.wanCircuitID,
            wANGatewaySpectraCPEwithmask: wanFormData.wanGateway,
            wANIPaddressSpecCPEmask: wanFormData.wanIPaddress,
            wANType: wanFormData.wanType,
            wanIPAllocationtype: wanFormData.wanIPAllocationtype,
            wanNo: "",
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName')
        };

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            // console.log("createWan API result:", result);
            fetchAllWan();
            setShowWanModal(false);
        } catch (error) {
            console.error("Error creating WAN", error);
        }
    };

    const handleupdateoppproduct = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            // 1. Call getOppProduct API
            const getOppPayload = {
                Action: "getOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: "", // include oppid if available
                reason: "",
                siteId: SiteID,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName')
            };

            const getOppResponse = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(getOppPayload)
            });
            const oppProducts = await getOppResponse.json();

            // 2. Extract OTC and RC product details from the response
            const { Data } = oppProducts?.Response || {};
            const otcProduct = Data && Data.find(product => product.ProductId.includes("OTC"));
            const rcProduct = Data && Data.find(product => product.ProductId.includes("RC"));

            // 3. Build payloads for updateOppProduct API calls

            // OTC Update payload
            const otcPayload = {
                Action: "updateOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId || "",
                siteId: SiteID || "",
                productid: otcProduct ? otcProduct.ProductId : "",
                discount: siteData.OTCDiscountAmount || "0",
                quantity: "",
                priceperunit: "",
                pricing: "Use Default",
                userName: sessionStorage.getItem('userName'),
                password: sessionStorage.getItem('password')
            };

            // RC Update payload
            const rcPayload = {
                Action: "updateOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId || "",
                siteId: SiteID || "",
                productid: rcProduct ? rcProduct.ProductId : "",
                discount: siteData.RCdiscountamount || "0",
                quantity: "",
                priceperunit: "",
                pricing: "Use Default",
                userName: sessionStorage.getItem('userName'),
                password: sessionStorage.getItem('password')
            };

            // 4. Call updateOppProduct API for OTC product
            const responseOTC = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(otcPayload)
            });
            const dataOTC = await responseOTC.json();

            // 5. Call updateOppProduct API for RC product
            const responseRC = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(rcPayload)
            });
            const dataRC = await responseRC.json();

            // Optionally, handle or display the responses from the update calls
            // console.log("OTC update response:", dataOTC);
            // console.log("RC update response:", dataRC);

            return { oppProducts, dataOTC, dataRC };
        } catch (err) {
            console.error("Error during API calls:", err);
            return err.message;
        }
    };

    const handleSaveLan = async () => {
        // Construct the payload for the createLan API using values from lanFormData.
        const payload = {
            Action: "createLan",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            additionalIpConfigured: "",
            additionalIpGateway: "",
            additionalIpPoolBetIspandFw: "",
            additionalIpPoolallocation: "",
            customerexistingIppool1: "",
            customerexistingIppool2: "",
            ipAllocationRange: lanFormData.ipAllocationRange,
            ipAllocationUser: "",
            ipPoolBetIspexistingL3: "",
            ipPoolGateway: lanFormData.ipPoolGateway,
            ipPoolGateway2: "",
            lanGatewayAddress: "",
            lanIPAllocationtoUser: lanFormData.lanIPAllocationtoUser,
            lanIpAddress: lanFormData.lanIpAddress,
            lanIpAddress2: "",
            lanIpPool: lanFormData.lanIpPool,
            lanIpPool2: lanFormData.lanIpPool2,
            lanIpPool3: "",
            lanIpallocation2: "",
            lanIpasIspCpe: "",
            // password: "S@lesperson@20#!24$",
            siteId: SiteID, // You can replace this with the actual siteId from your siteData
            // userName: "salesperson1",
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName')
        };

        try {
            const apiUrl = process.env.REACT_APP_API_URL; // Make sure this is defined in your .env
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            // console.log("createLan API result:", result);
            // You may want to notify the user of success or error here.
            // Close the popup on success.
            fetchAllLan();

            setShowLanModal(false);
        } catch (error) {
            console.error("Error creating LAN:", error);
        }
    };










    const [relationshipOptions, setRelationshipOptions] = useState([]);

    const [selectState, setSelectState] = useState(null);
    const [cityOptions, setCityOptions] = useState([]);
    const [createSite, setcreateSite] = useState(null);
    const [updateSite, setupdateSite] = useState(null);

    const [selectCity, setSelectCity] = useState(null);

    // const [loader, setLoader] = useState(false);
    const handleSolutionDeploymentChange = (selectedOption) => {
        setSelectedSolutionDeploymentMode(selectedOption);
    };

    const handleSiteCategoryChange = (selectedOption) => {
        setSelectedSiteCategory(selectedOption);
    };

    // Handle state selection
    const handleSelectState = (selectedOption) => {
        setSelectState(selectedOption);
        // Clear any previously selected city when state changes
        setSelectCity(null);
    };

    // Handle city selection
    const handleSelectCity = (selectedOption) => {
        setSelectCity(selectedOption);
    };
    const [siteData, setSiteData] = useState({
        SiteID: "",
        OpportunityId: "",
        OpportunityName: "",
        ContactPersonName: "",
        CustomerContactNumber: "",
        CustomerEmergencyContactNumber: "",
        CustomerEmailAddress: "",
        State: "",
        City: "",
        PinCode: "",
        Address: "",
        SolutionDeploymentMode: "",
        Company: "",
        Group: "",
        Relationship: "",
        SiteCategory: "",
        BusinessSegment: "",
        PresalesID: "",
        SafID: "",
        SubBusinessSegment: "",
        CustomerSegment: "",
        TypeOFOrder: "",
        SiteType: "",
        NoOfLanPool: "",
        NoOfWanlinks: "",
        PriceList: "",
        TotalAmount: "",
        SiteStatus: "",
        OppStatus: "",
        ProductName: "",
        ProductID: "",
        RCamount: "",
        RCdiscountamount: "",
        RCextendedamount: "",
        OTCAmount: "",
        OTCDiscountAmount: "",
        OTCextendedAmount: ""
    });
    // Dropdown selections
    const [selectedSolutionDeploymentMode, setSelectedSolutionDeploymentMode] = useState(null);
    const [selectedSiteCategory, setSelectedSiteCategory] = useState(null);
    //   const [selectState, setSelectState] = useState(null);
    //   const [selectCity, setSelectCity] = useState(null);
    //   const [cityOptions, setCityOptions] = useState([]);
    //   const [loader, setLoader] = useState(false);

    // Fetch site details from the API on mount

    // useEffect(() => {
    const fetchSiteData = async () => {
        try {
            setLoader(true);
            const apiUrl = process.env.REACT_APP_API_URL; // Ensure your API URL is set in your environment
            const requestBody = {
                Action: "getSite",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppID: OppId,
                siteID: SiteID,
                // password: "S@lesperson@20#!24$",
                // userName: "salesperson1",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName')
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });
            const result = await response.json();

            if (
                result.Status === "Success" &&
                result.Response.Data &&
                result.Response.Data.length > 0
            ) {
                const data = result.Response.Data[0];
                setSiteData(data);
                setOppId2(data.OpportunityId);
                fetchData(data.OpportunityId);

                // Set the dropdown selections by matching API response values
                const solutionDeployment = solutionDeploymentModeOptions.find(
                    (option) => option.value === data.SolutionDeploymentMode
                );
                setSelectedSolutionDeploymentMode(solutionDeployment);

                const siteCategory = siteCategoryOptions.find(
                    (option) => option.value === data.SiteCategory
                );
                setSelectedSiteCategory(siteCategory);

                // Match the state using the state name from the API.
                const stateOption = stateOptions.find(
                    (option) =>
                        option.label.toLowerCase() === data.State.toLowerCase()
                );
                setSelectState(stateOption);

                // For City, initially set based on API (the city list will be loaded next).
                setSelectCity({ value: data.City, label: data.City });
            }
        } catch (error) {
            console.error("Error fetching site data:", error);
        } finally {
            setLoader(false);
        }
    };

    //     fetchSiteData();
    // }, []);
    useEffect(() => {
        const fetchRelationship = async () => {
            try {
                setLoader(true);
                const relationshipApiUrl = process.env.REACT_APP_API_URL; // assuming same base API URL
                const requestBody = {
                    Action: "getRelationship",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    companyId: "CNew",
                    password: "Spectr@man#23!",
                    userName: "manager1",
                };

                const response = await fetch(relationshipApiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                });
                const result = await response.json();

                if (
                    result.Status === "Success" &&
                    result.Response.Data &&
                    Array.isArray(result.Response.Data)
                ) {
                    const relationships = result.Response.Data.map((rel) => ({
                        value: rel.Relationship_ID,
                        label: rel.Relationship_Name,
                    }));
                    setRelationshipOptions(relationships);

                    // If siteData already has Relationship value, try to set the selectedRelationship
                    if (siteData.Relationship) {
                        const selRel = relationships.find(
                            (rel) => rel.value === siteData.Relationship
                        );
                        if (selRel) {
                            setSelectedRelationship(selRel);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching relationship data:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchRelationship();
    }, [siteData.Relationship]);

    // Fetch cities when a state is selected
    useEffect(() => {
        const fetchCities = async () => {
            if (!selectState || !selectState.value) return;

            try {
                setLoader(true);
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem("password"),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem("userName"),
                };

                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    // Assuming each city object has properties "CityCode" and "CityName"
                    const cities = cityData.Response.Data.map((city) => ({
                        value: city.CityCode,
                        label: city.CityName,
                    }));
                    setCityOptions(cities);
                } else {
                    setCityOptions([]);
                }
            } catch (error) {
                console.error("Error fetching cities:", error);
                setCityOptions([]);
            } finally {
                setLoader(false);
            }
        };

        fetchCities();
    }, [selectState]);

    const handleSave = async () => {
        // console.log("createupdateSite", createupdateSite)


        const updatePayload = {
            Action: createupdateSite,
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            address: siteData.Address,
            city: selectCity ? selectCity.value : "", // city code from dropdown
            contactPersonName: siteData.ContactPersonName,
            customerContactNumber: siteData.CustomerContactNumber,
            customerEmailAddress: siteData.CustomerEmailAddress,
            customerEmergencyContactNumber: siteData.CustomerEmergencyContactNumber,
            noOfLanPool: siteData.NoOfLanPool,
            noOfWanlinks: siteData.NoOfWanlinks,
            opportunityId: siteData.OpportunityId,
            // password: "S@lesperson@20#!24$", // or get from state/environment
            pinCode: siteData.PinCode,
            priceList: siteData.PriceList,
            relationship: selectedRelationship ? selectedRelationship.value : "",
            siteCategory: selectedSiteCategory ? selectedSiteCategory.value : "",
            siteID: siteData.SiteID,
            siteType: "122050000", // assuming site type is editable
            solutionDeploymentMode: selectedSolutionDeploymentMode
                ? selectedSolutionDeploymentMode.value
                : "",
            state: selectState ? selectState.value : "",
            totalAmount: siteData.TotalAmount,
            // userName: "salesperson1", // or from sessionStorage
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName')
        };

        try {
            setLoader(true);
            const apiUrl = process.env.REACT_APP_API_URL; // Update if necessary
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updatePayload),
            });
            const result = await response.json();
            // console.log("UpdateSite API result:", result);

            // navigate(`/businessOpportunityForm?OppId=${OppId}`);

            // You can handle success or errors based on result here.
        } catch (error) {
            console.error("Error updating site:", error);
        } finally {
            setLoader(false);
        }
    };
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "30px",
            height: "30px"
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "30px",
            padding: "0 6px"
        }),
        input: (provided) => ({
            ...provided,
            margin: "0px"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "30px"
        })
    };

    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectoppPage}


                    // onClick={redirectoppPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className=" " >Add Site</span>

                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (

                <form>
                    <div className="container-fluid mb-4 form-container">


                        < div
                            className="contact-toggle mt-3"
                            onClick={() => handleIconClick("form21")}
                        >
                            <span className="toggle-text">Basic Site Details</span>
                            <span className="float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form21" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form21"
                            >
                                <fieldset className="contact-form p-2">
                                    {/* Site ID */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Site ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="siteId"
                                            name="SiteID"
                                            value={siteData.SiteID}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="siteId" className="mt-2">
                                            Site ID*
                                        </label>
                                    </div>

                                    {/* Opportunity ID */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="OpportunityId"
                                            name="OpportunityId"
                                            value={siteData.OpportunityId}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="OpportunityId" className="mt-2">
                                            Opportunity ID*
                                        </label>
                                    </div>

                                    {/* Opp Name */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opp Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="OpportunityName"
                                            name="OpportunityName"
                                            value={siteData.OpportunityName}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="OpportunityName" className="mt-2">
                                            Opportunity Name*
                                        </label>
                                    </div>

                                    {/* Contact Person Name */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Contact Person Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="ContactPersonName"
                                            name="ContactPersonName"
                                            value={siteData.ContactPersonName}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="ContactPersonName" className="mt-2">
                                            Contact Person Name*
                                        </label>
                                    </div>

                                    {/* Customer Contact Number */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="tel"
                                            placeholder="Customer Contact Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="CustomerContactNumber"
                                            name="CustomerContactNumber"
                                            value={siteData.CustomerContactNumber}
                                            maxLength="10"
                                            pattern="[0-9]{10}"
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                // if (
                                                //   (isDigit || allowedKeys.includes(e.key)) &&
                                                //   (buildPin1.length < 6 || e.key === "Backspace")
                                                // ) {
                                                //   return true;
                                                // } else {
                                                //   e.preventDefault();
                                                // }
                                            }}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="CustomerContactNumber" className="mt-2">
                                            Customer Contact Number*
                                        </label>
                                    </div>

                                    {/* Customer Emergency Contact Number */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="tel"
                                            placeholder="Customer Emergency Contact Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="CustomerEmergencyContactNumber"
                                            name="CustomerEmergencyContactNumber"
                                            value={siteData.CustomerEmergencyContactNumber}
                                            maxLength="10"
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                // if (
                                                //   (isDigit || allowedKeys.includes(e.key)) &&
                                                //   (buildPin1.length < 6 || e.key === "Backspace")
                                                // ) {
                                                //   return true;
                                                // } else {
                                                //   e.preventDefault();
                                                // }
                                            }}
                                            pattern="[0-9]{10}"
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="CustomerEmergencyContactNumber" className="mt-2">
                                            Customer Emergency Contact Number*
                                        </label>
                                    </div>

                                    {/* Customer Email Address */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Customer Email Address"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="CustomerEmailAddress"
                                            name="CustomerEmailAddress"
                                            value={siteData.CustomerEmailAddress}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="CustomerEmailAddress" className="mt-2">
                                            Customer Email Address*
                                        </label>
                                    </div>

                                    {/* State Dropdown */}
                                    <div className="mt-3">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="state"
                                            placeholder="Select State"
                                            options={stateOptions}
                                            value={selectState}
                                            onChange={handleSelectState}
                                            isSearchable={false}
                                        />
                                    </div>

                                    {/* City Dropdown */}
                                    <div className="mt-3">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="city"
                                            placeholder="Select City"
                                            options={cityOptions}
                                            value={selectCity}
                                            onChange={handleSelectCity}
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    {/* Address */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Address"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Address"
                                            name="Address"
                                            value={siteData.Address}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="Address" className="mt-2">
                                            Address*
                                        </label>
                                    </div>

                                    {/* Solution Deployment Modes Dropdown */}
                                    <div className="mt-3">
                                        <label className="select-search-label mt-1">
                                            Solution Deployment Modes*
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="solutionDeploymentModes"
                                            options={solutionDeploymentModeOptions}
                                            value={selectedSolutionDeploymentMode}
                                            onChange={handleSolutionDeploymentChange}
                                            placeholder="Select Solution Deployment Mode"
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    {/* Company */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Company"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Company"
                                            name="Company"
                                            value={siteData.Company}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="Company" className="mt-2">
                                            Company*
                                        </label>
                                    </div>

                                    {/* Group */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Group"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Group"
                                            name="Group"
                                            value={siteData.Group}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="Group" className="mt-2">
                                            Group*
                                        </label>
                                    </div>

                                    {/* Relationship */}
                                    <div className="mt-3">
                                        <label className="select-search-label mt-1">Relationship*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="relationship"
                                            options={relationshipOptions}
                                            value={selectedRelationship}
                                            onChange={handleRelationshipChange}
                                            placeholder="Select Relationship"
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    {/* Site Category Dropdown */}
                                    <div className="mt-3">
                                        <label className="select-search-label mt-1">Site Category*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="siteCategory"
                                            options={siteCategoryOptions}
                                            value={selectedSiteCategory}
                                            onChange={handleSiteCategoryChange}
                                            placeholder="Select Site Category"
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    {/* Business Segment */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Business Segment"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="BusinessSegment"
                                            name="BusinessSegment"
                                            value={siteData.BusinessSegment}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="BusinessSegment" className="mt-2">
                                            Business Segment*
                                        </label>
                                    </div>

                                    {/* Sub Business Segment */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Sub Business Segment"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="SubBusinessSegment"
                                            name="SubBusinessSegment"
                                            value={siteData.SubBusinessSegment}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="SubBusinessSegment" className="mt-2">
                                            Sub Business Segment*
                                        </label>
                                    </div>

                                    {/* Customer Segment */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Customer Segment"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="CustomerSegment"
                                            name="CustomerSegment"
                                            value={siteData.CustomerSegment}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="CustomerSegment" className="mt-2">
                                            Customer Segment*
                                        </label>
                                    </div>

                                    {/* Type of Order */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Type of Order"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="TypeOFOrder"
                                            name="TypeOFOrder"
                                            value={siteData.TypeOFOrder}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="TypeOFOrder" className="mt-2">
                                            Type of Order*
                                        </label>
                                    </div>

                                    {/* Site Type */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Site Type"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="SiteType"
                                            name="SiteType"
                                            value={siteData.SiteType}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="SiteType" className="mt-2">
                                            Site Type*
                                        </label>
                                    </div>

                                    {/* No. of WAN Links */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="No. of WAN Links"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="NoOfWanlinks"
                                            name="NoOfWanlinks"
                                            value={siteData.NoOfWanlinks}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="NoOfWanlinks" className="mt-2">
                                            No. of WAN Links*
                                        </label>
                                    </div>

                                    {/* No. of LAN Pools */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="No. of LAN Pools"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="NoOfLanPool"
                                            name="NoOfLanPool"
                                            value={siteData.NoOfLanPool}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="NoOfLanPool" className="mt-2">
                                            No. of LAN Pools*
                                        </label>
                                    </div>

                                    {/* Amount */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Amount"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="TotalAmount"
                                            name="TotalAmount"
                                            value={siteData.TotalAmount}
                                            onChange={handleChange}
                                            readOnly
                                        />
                                        <label htmlFor="TotalAmount" className="mt-2">
                                            Amount*
                                        </label>
                                    </div>
                                </fieldset>

                                {/* {!SiteID && ( */}
                                <div className="text-center mt-5 mb-3">
                                    <button
                                        type="button"
                                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                        style={{
                                            width: "90px",
                                            fontSize: "16px",
                                            padding: "6px",
                                            fontWeight: "bold",
                                        }}
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                </div>
                                {/* )} */}
                            </div>
                        )}


                        < div
                            className="contact-toggle mt-3"
                            onClick={() => handleIconClick("form23")}
                        >
                            <span className="toggle-text">LAN Details</span>
                            <span className="float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form23" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form23"
                            >
                                <fieldset className="contact-form p-2">
                                    {/* No. of location - free text field */}
                                    <div className="d-flex justify-content-center gap-1">
                                        <button
                                            type="button"
                                            className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                            style={{
                                                width: "90px",
                                                fontSize: "16px",
                                                padding: "6px",
                                                fontWeight: "bold",
                                            }}
                                            onClick={() => setShowLanModal(true)}                                        >
                                            Add LAN
                                        </button>
                                    </div>
                                    <div className="row mt-3">
                                        {lanCards.map((lan, index) => (
                                            <div key={index} >
                                                <div className="card">
                                                    <div className="card-body">
                                                        <p>
                                                            <strong>Lan No:</strong> {lan.LanNo}
                                                        </p>
                                                        <p>
                                                            <strong>IP Allocation:</strong> {lan.LanIPAllocationtoUser}
                                                        </p>
                                                        <p>
                                                            <strong>Solution Deployment Mode:</strong>{" "}
                                                            {lan.SolutionDeploymentMode}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </fieldset>
                            </div>
                        )}



                        < div
                            className="contact-toggle mt-3"
                            onClick={() => handleIconClick("form24")}
                        >
                            <span className="toggle-text">WAN Details</span>
                            <span className="float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form24" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form24"
                            >
                                <fieldset className="contact-form p-2">
                                    {/* No. of location - free text field */}
                                    <div className="d-flex justify-content-center gap-1">
                                        <button
                                            type="button"
                                            className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                            style={{
                                                width: "90px",
                                                fontSize: "16px",
                                                padding: "6px",
                                                fontWeight: "bold",
                                            }}
                                            onClick={() => setShowWanModal(true)}
                                        >
                                            Add WAN
                                        </button>
                                    </div>
                                    <div className="row mt-3">
                                        {wanCards.map((wan, index) => (
                                            <div key={index} >
                                                <div className="card">
                                                    <div className="card-body">
                                                        <p>
                                                            <strong>Wan No:</strong> {wan.WanNo}
                                                        </p>
                                                        <p>
                                                            <strong>IP Allocation:</strong> {wan.WanIPAllocationtype}
                                                        </p>
                                                        <p>
                                                            <strong>Solution Deployment Mode:</strong>{" "}
                                                            {wan.SolutionDeploymentMode}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </fieldset>
                            </div>
                        )}

                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form5")}
                        >
                            <span className="toggle-text">Product Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>
                        {activeForm === "form5" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form5">
                                <fieldset className="Remarks-form p-2">

                                    <div className="Other-details-toggle mt-3">
                                        <form className="Other-details-form p-2">

                                            <div className="">
                                                <label className="select-search-label mt-1">
                                                    Price list*
                                                </label>
                                                <Select
                                                    className=" basic-single form-control form-control-sm p-1"
                                                    classNamePrefix="select"
                                                    name="Price"
                                                    placeholder="Select Price List"
                                                    styles={style}
                                                    value={selectedPriceList}
                                                    isSearchable={true}
                                                    onChange={handlePriceListChange}
                                                    options={options}

                                                />
                                            </div>
                                            {!siteData.ProductName && (
                                                <div className="">
                                                    <label className="select-search-label mt-1">
                                                        Product list*
                                                    </label>
                                                    <Select
                                                        className=" basic-single form-control form-control-sm p-1"
                                                        classNamePrefix="select"
                                                        name="Product"
                                                        placeholder="Select Product"
                                                        styles={style}
                                                        value={selectedProduct}
                                                        isSearchable={true}
                                                        onChange={handleProductChange}
                                                        options={productOptions.map((data) => ({
                                                            value: data.value,
                                                            label: data.label,
                                                        }))}
                                                    />
                                                </div>
                                            )}
                                            {siteData.ProductName && (

                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="Enter reason"
                                                        className="form-control input-text form-control-sm mt-1"
                                                        id="reason"
                                                        name="ProductName"
                                                        value={siteData.ProductName}
                                                        onChange={handleChange}
                                                        readOnly
                                                        style={{ background: "transparent" }}
                                                    />
                                                    <label htmlFor="reason" className="mt-2">Product Name</label>
                                                </div>
                                            )}
                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Enter reason"
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="reason"
                                                    name="Reason"
                                                    value={opportunityData.Reason || "NA"}
                                                    onChange={handleChange1}
                                                    readOnly
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="reason" className="mt-2">Reason</label>
                                            </div>

                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Enter OTC Amount"
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="otcAmount"
                                                    name="OTCAmount"
                                                    value={siteData.OTCAmount || "0.00"}
                                                    onChange={handleChange}
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="otcAmount" className="mt-2">OTC Amount</label>
                                            </div>

                                            <div className="input-box form-floating">
                                                <input
                                                    type="number"
                                                    placeholder="Enter SD Amount"
                                                    className="form-control input-text form-control-sm mt-2"
                                                    id="otcDiscount"
                                                    name="OTCDiscountAmount"
                                                    value={siteData.OTCDiscountAmount}
                                                    onChange={handleChange}
                                                    // onBlur={discountInput}
                                                    disabled={!discountFlag == "OTC"}
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="sdAmount" className="mt-2">OTC Discount</label>
                                            </div>

                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Enter SD Amount"
                                                    className="form-control input-text form-control-sm mt-2"
                                                    id="discount"
                                                    name="discount"
                                                    value={siteData.OTCextendedAmount || "NA"}
                                                    onChange={handleChange}
                                                    disabled
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="sdAmount" className="mt-2">Extended OTC Amount</label>
                                            </div>

                                            {/* <div className="input-box form-floating">
                      <input
                        type="number"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="sdAmount"
                        name="SDAmount"
                        value={opportunityData.SDAmount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">SD Amount</label>
                    </div> */}



                                            <div className="input-box form-floating">
                                                <input
                                                    type="number"
                                                    placeholder="Enter RC Amount"
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="rcAmount"
                                                    name="RCamount"
                                                    value={siteData.RCamount || "0.00"}
                                                    onChange={handleChange}
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="rcAmount" className="mt-2">RC Amount</label>
                                            </div>


                                            <div className="input-box form-floating">
                                                <input
                                                    type="number"
                                                    placeholder="Enter SD Amount"
                                                    className="form-control input-text form-control-sm mt-2"
                                                    id="sdDiscount"
                                                    name="RCdiscountamount"
                                                    value={siteData.RCdiscountamount}
                                                    onChange={handleChange}
                                                    // onBlur={discountInput}
                                                    disabled={!discountFlag == "RC"}
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="sdAmount" className="mt-2">RC Discount</label>
                                            </div>

                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Enter SD Amount"
                                                    className="form-control input-text form-control-sm mt-2"
                                                    id="discount"
                                                    name="exRcDiscount"
                                                    value={siteData.RCextendedamount || "NA"}
                                                    onChange={handleChange}
                                                    disabled
                                                    style={{ background: "transparent" }}
                                                />
                                                <label htmlFor="sdAmount" className="mt-2">Extended RC Amount</label>
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <button
                                                    type="button"
                                                    className="btn text-light submit-btn bg-dark rounded-pill"
                                                    style={{
                                                        width: "90px",
                                                        fontSize: "16px",
                                                        padding: "6px",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={handleupdateoppproduct}
                                                >
                                                    Save
                                                </button>
                                            </div>

                                            {/* <div className="">
                        <label className="select-search-label mt-1">
                          Related Products
                        </label>
                        <Select
                          className=" basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="Product"
                          placeholder="Select Related Product"
                          styles={style}
                          value={selectedRelatedProduct}
                          isSearchable={true}
                          onChange={relatedProductChange}
                          options={relatedProductOptions?.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />
                      </div> */}


                                            {/* <div className=" text-center mt-5 mb-3">
                      <button
                        type="submit"
                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                        onClick={handleSendToApproval}
                      >
                        Submit for Approval
                      </button>
                    </div> */}
                                            {/* {console.log("otcDiscount",opportunityData?.otcDiscount, statusCode)} */}


                                        </form>
                                    </div>

                                </fieldset>
                            </div>)}







                        {showWanModal && (
                            <div
                                className="modal-overlay"
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 1000,
                                }}
                            >
                                <div
                                    className="modal-content container shadow bg-body rounded p-4"
                                    style={{ maxWidth: "500px" }}
                                >
                                    <h5 className="mb-3">Add WAN Details</h5>
                                    <fieldset className="contact-form p-2">
                                        {/* WAN IP Allocation Type */}
                                        <div className="mb-3">
                                            <label className="select-search-label mt-1">
                                                WAN IP Allocation Type*
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="wanIPAllocationtype"
                                                options={wanIpAllocationOptions}
                                                placeholder="Select Option"
                                                onChange={(option) =>
                                                    handleWanDropdownChange("wanIPAllocationtype", option)
                                                }
                                            />
                                        </div>
                                        {/* WAN Type */}
                                        <div className="mb-3">
                                            <label className="select-search-label mt-1">WAN Type*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="wanType"
                                                options={wanTypeOptions}
                                                placeholder="Select Option"
                                                onChange={(option) => handleWanDropdownChange("wanType", option)}
                                            />
                                        </div>
                                        {/* WAN Bandwidth (Mbps) */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="WAN Bandwidth (Mbps)"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="wanBandwidth"
                                                name="wanBandwidth"
                                                value={wanFormData.wanBandwidth}
                                                onChange={handleWanChange}
                                            />
                                            <label htmlFor="wanBandwidth" className="mt-2">
                                                WAN Bandwidth (Mbps)*
                                            </label>
                                        </div>
                                        {/* WAN Gateway @ISP CPE with mask */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="WAN Gateway @ISP CPE with mask"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="wanGateway"
                                                name="wanGateway"
                                                value={wanFormData.wanGateway}
                                                onChange={handleWanChange}
                                            />
                                            <label htmlFor="wanGateway" className="mt-2">
                                                WAN Gateway @ISP CPE with mask*
                                            </label>
                                        </div>
                                        {/* WAN Circuit ID */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="WAN Circuit ID"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="wanCircuitID"
                                                name="wanCircuitID"
                                                value={wanFormData.wanCircuitID}
                                                onChange={handleWanChange}
                                            />
                                            <label htmlFor="wanCircuitID" className="mt-2">
                                                WAN Circuit ID*
                                            </label>
                                        </div>
                                        {/* WAN IP Address @ISP CPE with mask */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="WAN IP Address @ISP CPE with mask"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="wanIPaddress"
                                                name="wanIPaddress"
                                                value={wanFormData.wanIPaddress}
                                                onChange={handleWanChange}
                                            />
                                            <label htmlFor="wanIPaddress" className="mt-2">
                                                WAN IP Address @ISP CPE with mask*
                                            </label>
                                        </div>
                                        {/* WAN BB Provider */}
                                        <div className="mb-3">
                                            <label className="select-search-label mt-1">WAN BB Provider*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="wanBBProvider"
                                                options={wanBBProviderOptions}
                                                placeholder="Select Option"
                                                onChange={(option) =>
                                                    handleWanDropdownChange("wanBBProvider", option)
                                                }
                                            />
                                        </div>
                                    </fieldset>
                                    <div className="text-center mt-4">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            style={{ width: "90px", fontSize: "16px", padding: "6px", fontWeight: "bold" }}
                                            onClick={handleSaveWan}
                                        >
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary mx-2 rounded-pill"
                                            onClick={() => setShowWanModal(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showLanModal && (
                            <div
                                className="modal-overlay"
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 1000,
                                }}
                            >
                                <div
                                    className="modal-content container shadow bg-body rounded p-4"
                                    style={{ maxWidth: "500px" }}
                                >
                                    <h5 className="mb-3">Add LAN Details</h5>
                                    <fieldset className="contact-form p-2">
                                        {/* LAN IP Allocation to user - dropdown */}
                                        <div className="mb-3">
                                            <label className="select-search-label mt-1">
                                                LAN IP Allocation to user*
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="lanIPAllocationtoUser"
                                                options={lanIpAllocationOptions}
                                                placeholder="Select Option"
                                                onChange={handleLanDropdownChange}
                                            />
                                        </div>

                                        {/* LAN IP Allocation Range - free text field */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="LAN IP Allocation Range"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ipAllocationRange"
                                                name="ipAllocationRange"
                                                value={lanFormData.ipAllocationRange}
                                                onChange={handleLanChange}
                                            />
                                            <label htmlFor="ipAllocationRange" className="mt-2">
                                                LAN IP Allocation Range*
                                            </label>
                                        </div>

                                        {/* LAN IP pool - free text field */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="LAN IP pool"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="lanIpPool"
                                                name="lanIpPool"
                                                value={lanFormData.lanIpPool}
                                                onChange={handleLanChange}
                                            />
                                            <label htmlFor="lanIpPool" className="mt-2">
                                                LAN IP pool*
                                            </label>
                                        </div>

                                        {/* LAN IP Address@ISP CPE - free text field */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="LAN IP Address@ISP CPE"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="lanIpAddress"
                                                name="lanIpAddress"
                                                value={lanFormData.lanIpAddress}
                                                onChange={handleLanChange}
                                            />
                                            <label htmlFor="lanIpAddress" className="mt-2">
                                                LAN IP Address@ISP CPE*
                                            </label>
                                        </div>

                                        {/* LAN IP Pool Gateway - free text field */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="LAN IP Pool Gateway"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ipPoolGateway"
                                                name="ipPoolGateway"
                                                value={lanFormData.ipPoolGateway}
                                                onChange={handleLanChange}
                                            />
                                            <label htmlFor="ipPoolGateway" className="mt-2">
                                                LAN IP Pool Gateway*
                                            </label>
                                        </div>

                                        {/* LAN IP Pool 2 - free text field */}
                                        <div className="input-box form-floating mb-3">
                                            <input
                                                type="text"
                                                placeholder="LAN IP Pool 2"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="lanIpPool2"
                                                name="lanIpPool2"
                                                value={lanFormData.lanIpPool2}
                                                onChange={handleLanChange}
                                            />
                                            <label htmlFor="lanIpPool2" className="mt-2">
                                                LAN IP Pool 2*
                                            </label>
                                        </div>
                                    </fieldset>

                                    {/* Popup Save Button */}
                                    <div className="text-center mt-4">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            style={{
                                                width: "90px",
                                                fontSize: "16px",
                                                padding: "6px",
                                                fontWeight: "bold",
                                            }}
                                            onClick={handleSaveLan}
                                        >
                                            Save
                                        </button>
                                        {/* Optionally add a Cancel/Close button */}
                                        <button
                                            type="button"
                                            className="btn btn-secondary mx-2 rounded-pill"
                                            onClick={() => setShowLanModal(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                </form >

            )}
        </>
    );
};

export default BusinessSitedetails;
